module.exports = __webpack_public_path__ + "static/media/3.18_preview.5eebeda4.png";